import React, { useState } from "react";
import AsyncSelect from "react-select/async";

type Usuario = {
    id: number;
    nome: string;
};

type Props = {
    inputName: string;
    value?: Usuario;
    placeholder?: string;
    className?: string;
    containerClassName?: string;
    isClearable?: boolean;
};

export function AutocompleteUsuario({
                                        inputName,
                                        value,
                                        placeholder = "Digite o nome do usuário...",
                                        className,
                                        containerClassName,
                                        isClearable = true
                                    }: Props) {
    const [selected, setSelected] = useState<Usuario | null | undefined>(value);

    const loadOptions = async (inputValue: string) => {
        if (inputValue.length < 2) return [];
        const response = await fetch(`/historico-geracao/autocomplete_usuario?q=${encodeURIComponent(inputValue)}`);
        return await response.json();
    };

    return (
        <div className={containerClassName}>
            <AsyncSelect
                cacheOptions
                defaultOptions
                loadOptions={loadOptions}
                onChange={(option) => setSelected(option)}
                value={selected}
                getOptionValue={(u) => (u?.id ?? '').toString()}
                getOptionLabel={(u) => u?.nome ?? ''}
                className={`basic-single ${className}`}
                classNamePrefix="autocomplete"
                placeholder={placeholder}
                isClearable={isClearable}
                name={inputName}
                components={{ DropdownIndicator: null }}
                styles={{
                    menuList: (base) => ({
                        ...base,
                        maxHeight: 130,
                        overflowY: 'auto',
                    }),
                }}
            />

        </div>
    );
}
